<template>
    <div class="flex-1 flex flex-col justify-between">
        <div class="px-3">
            <div class="max-w-[1331px] w-full mx-auto overflow-hidden relative">

                <div class="homepage-top-background absolute top-0 left-0 flex justify-center items-center h-[736px] w-full z-2 rounded-[20px]">
                </div>

                <div class="z-3 relative">
                    <h2 class="text-[35px] md:text-[46px] text-center leading-[1.3] font-[CircularBold] mb-1.2 pt-[2.25em] text-[#366fed] uppercase">{{app_name}}</h2>
                    <h2 class="text-[35px] md:text-[50px] text-center leading-[1.3] font-[CircularBold] mb-3">Crypto Exchange</h2>
                    <div class="text-center max-w-[560px] w-full mx-auto mb-7 px-[15px]">
                        <div class="inline-flex flex-wrap justify-center gap-x-6 gap-y-4">
                            <div class="flex gap-3 items-center text-[18px] font-[CircularBook]">
                                <img src="@/../img/coins/eth.svg" alt="">
                                <span class="block">Ethereum</span>
                            </div>
                            <div class="flex gap-3 items-center text-[18px] font-[CircularBook]">
                                <img src="@/../img/coins/btc.svg" alt="">
                                <span class="block">Bitcoin</span>
                            </div>
                            <div class="flex gap-3 items-center text-[18px] font-[CircularBook]">
                                <img src="@/../img/coins/xrp.svg" alt="">
                                <span class="block">XRP</span>
                            </div>
                            <div class="flex gap-3 items-center text-[18px] font-[CircularBook]">
                                <img src="@/../img/coins/doge.svg" alt="">
                                <span class="block">DogeCoin</span>
                            </div>
                            <div class="flex gap-3 items-center text-[18px] font-[CircularBook]">
                                <img src="@/../img/coins/avax.svg" alt="">
                                <span class="block">Avax</span>
                            </div>
                            <div class="flex gap-3 items-center text-[18px] font-[CircularBook]">
                                <img class="w-[33px] h-[33px]" src="@/../img/coins/trump.svg" alt="">
                                <span class="block">Official Trump</span>
                            </div>
                        </div>
                    </div>

                    <div class="mb-[3em]">
                        <a
                            v-if="!logged"
                            href="/register"
                            class="flex flex-wrap items-center justify-center gap-2 w-fit mx-auto text-center bg-[#366fed] hover:bg-[#5282eb] text-[16px] sm:text-[20px] text-white font-[CircularMedium]] rounded-[10px] py-[.7em] px-[1.5em] mb-10 pointer"
                        >
                            <img src="@/../img/icons/gift.svg" alt="gift">
                            <span>
                                Register
                            </span>
                        </a>
                        <a
                            v-if="logged"
                            href="/account"
                            class="block max-w-[180px] mx-auto text-center bg-[#366fed] hover:bg-[#5282eb] text-[18px] text-white font-[CircularMedium] rounded-[10px] py-[.66em] px-[.75em] mb-10 pointer"
                        >
                            My profile
                        </a>
                    </div>

                    <div class="flex flex-wrap items-center justify-center gap-10 mb-[2em] sm:mb-[6.5em]">
                        <div class="flex items-center text-center text-[18px] font-[600]">
                            <img src="@/../img/icons/decoration.svg" alt="decoration">
                            <div>
                                <p class="text-[#366fed]">Backed by Trust</p>
                                <p>
                                    <span class="font-[400]">Since</span> <span>2017</span>
                                </p>
                            </div>
                            <img class="scale-x-[-1]" src="@/../img/icons/decoration.svg" alt="decoration">
                        </div>
                        <div class="flex items-center text-center text-[18px] font-[600]">
                            <img src="@/../img/icons/decoration.svg" alt="decoration">
                            <div>
                                <p class="text-[#366fed]">Built for Everyone</p>
                                <p>
                                    <span>190+</span> <span class="font-[400]">Countries</span>
                                </p>
                            </div>
                            <img class="scale-x-[-1]" src="@/../img/icons/decoration.svg" alt="decoration">
                        </div>
                    </div>

                    <div class="max-w-[1145px] px-[15px] mx-auto mb-2">
                        <div class="bg-white rounded-[15px] px-2 sm:px-6 py-[.72em] border border-[#eeeff2]">
                            <p class="text-center text-[16px] sm:text-[25px] font-[600] tracking-[1px]">Earn More with <span class="text-[#366fed] uppercase">{{ app_name }}</span></p>
                        </div>
                    </div>

                    <FeaturedMarkets :showBorder="true" />
                </div>
                <MarketTrend :showBorder="true"/>

                <div class="mb-[3em] sm:mb-[7em]">
                    <div class="max-w-[1145px] px-[15px] mx-auto">
                        <p class="text-center text-[25px] sm:text-[40px] font-[600] tracking-[1px] mb-[1.3em]">Earn More with <span class="text-[#366fed] uppercase">{{ app_name }}</span></p>
                        <div class="grid md:grid-cols-3 gap-[12px]">
                            <div class="flex flex-col justify-between border border-[#dce7ff] bg-white rounded-[15px] overflow-hidden px-4 pb-8">
                                <img
                                    class="max-w-[150px] w-full md:max-w-full mx-auto"
                                    src="@/../img/landing/partner.png" alt="icon"
                                >
                                <div>
                                    <span class="block text-[20px] sm:text-[25px] font-[600] mb-2.5 text-center">Become a Listing Partner</span>
                                </div>
                            </div>
                            <div class="flex flex-col justify-between border border-[#dce7ff] bg-white rounded-[15px] overflow-hidden px-4 pb-8">
                                <img
                                    class="max-w-[150px] w-full md:max-w-full mx-auto"
                                    src="@/../img/landing/reward.png" alt="icon"
                                >
                                <div>
                                    <span class="block text-[20px] sm:text-[25px] font-[600] mb-2.5 text-center">Become dOTC Partners</span>
                                </div>
                            </div>
                            <div class="flex flex-col justify-between border border-[#dce7ff] bg-white rounded-[15px] overflow-hidden px-4 pb-8">
                                <img
                                    class="max-w-[150px] w-full md:max-w-full mx-auto"
                                    src="@/../img/landing/ambassador.png" alt="icon"
                                >
                                <div>
                                    <span class="block text-[20px] sm:text-[25px] font-[600] mb-2.5 text-center">Contact Our Support</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

<!--                <div class="max-w-[1145px] px-[15px] mx-auto mb-2">-->
<!--                    <div class="bg-white rounded-[15px] px-6 py-[.72em] border border-[#eeeff2] mb-[2.2em]">-->
<!--                        <p class="text-center text-[18px] sm:text-[25px] font-[600] tracking-[1px]">Special Events with <span class="text-[#366fed] uppercase">{{ app_name }}</span></p>-->
<!--                    </div>-->
<!--                    <div class="flex flex-wrap items-center gap-2 justify-center">-->
<!--                        <span class="text-[30px] sm:text-[40px] text-center md:text-left font-[600]">BitexLive Grant Program</span>-->
<!--                    </div>-->
<!--                    <p class="text-center max-w-[600px] w-full mx-auto text-[16px] tracking-[-.5px] mb-4">We invite builders to apply for grants to enhance community engagement and foster educational initiatives.</p>-->
<!--                    <a-->
<!--                        href="https://forms.gle/YaVbjYRjZMQm9S3R7"-->
<!--                        target="_blank"-->
<!--                        class="mb-[1.8em] block border hover:bg-[#5282eb] hover:text-white !border-[#366fed] bg-[#366fed] rounded-[10px] w-fit text-base font-[500] text-[#fff] px-3 py-2 mx-auto"-->
<!--                    >-->
<!--                        Apply Now-->
<!--                    </a>-->
<!--                    <div class="grid grid-cols-6 gap-[12px] max-w-[820px] w-full mx-auto mb-[2em] sm:mb-[5em]">-->
<!--                        <div class="border border-[#dce7ff] rounded-[15px] overflow-hidden col-span-6 md:col-span-3 flex flex-col sm:flex-row items-center gap-5 pl-4 pr-2 py-3">-->
<!--                            <img src="@/../img/landing/icons/stock.svg" alt="">-->
<!--                            <span class="text-[15px] tracking-[-.5px]">Get funding in tokens and <br> support from the community</span>-->
<!--                        </div>-->
<!--                        <div class="border border-[#dce7ff] rounded-[15px] overflow-hidden col-span-6 md:col-span-3 flex flex-col sm:flex-row items-center gap-5 pl-4 pr-2 py-3">-->
<!--                            <img src="@/../img/landing/icons/wand.svg" alt="">-->
<!--                            <span class="text-[15px] tracking-[-.5px]">Launch a Smart Contract with Zero Coding <br> Knowledge using Apertum Contracts Wizard</span>-->
<!--                        </div>-->
<!--                        <div class="border border-[#dce7ff] rounded-[15px] overflow-hidden col-span-6 md:col-span-2 flex flex-col sm:flex-row items-center gap-5 pl-4 pr-2 py-3">-->
<!--                            <img src="@/../img/landing/icons/drop.svg" alt="">-->
<!--                            <span class="text-[15px] tracking-[-.5px]">Boost your liquidity</span>-->
<!--                        </div>-->
<!--                        <div class="border border-[#dce7ff] rounded-[15px] overflow-hidden col-span-6 md:col-span-2 flex flex-col sm:flex-row items-center gap-5 pl-4 pr-2 py-3">-->
<!--                            <img src="@/../img/landing/icons/expand.svg" alt="">-->
<!--                            <span class="text-[15px] tracking-[-.5px]">Expand your <br> ecosystem</span>-->
<!--                        </div>-->
<!--                        <div class="border border-[#dce7ff] rounded-[15px] overflow-hidden col-span-6 md:col-span-2 flex flex-col sm:flex-row items-center gap-5 pl-4 pr-2 py-3">-->
<!--                            <img src="@/../img/landing/icons/brand.svg" alt="">-->
<!--                            <span class="text-[15px] tracking-[-.5px]">Grow your brand</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="max-w-[1145px] px-[15px] mx-auto mb-5">
                    <div class="border border-[#dce7ff] rounded-[15px] overflow-hidden col-span-3 px-[1em] sm:px-[3em] py-[3em] sm:pt-[7.5em] sm:pb-[7.8em] bg-[url('@/../img/landing/gifts.png')] bg-cover">
                        <div class="flex flex-wrap items-center gap-2 text-[25px] font-[600] mb-4">
                            <img src="@/../img/logo/logo.svg" alt="">
                        </div>
                        <span class="block text-[25px] sm:text-[30px] md:text-[40px] leading-[1] font-[600] mb-0">Become a Member <br> and stand a chance to </span>
                        <span class="block text-[25px] sm:text-[30px] md:text-[40px] leading-[1] text-[#366fed] font-[600]">win multiple prizes.</span>
                    </div>
                </div>

<!--                <div class="max-w-[1145px] px-[15px] mx-auto mb-[2em] sm:mb-[3em]">-->
<!--                    <div class="border border-[#dce7ff] rounded-[15px] overflow-hidden col-span-3 px-[1em] sm:px-[3em] py-[3em] sm:pt-[7.5em] sm:pb-[7.8em] bg-[url('@/../img/landing/roulette-bg.png')] bg-cover grid grid-cols-2 gap-[6em]">-->
<!--                        <div class="col-span-2 md:col-start-2">-->
<!--                            <div class="flex flex-wrap items-center gap-2 text-[25px] font-[600] mb-4">-->
<!--                                <img src="@/../img/logo/logo.svg" alt="">-->
<!--                            </div>-->
<!--                            <span class="block text-[25px] sm:text-[30px] md:text-[40px] leading-[1] font-[600] mb-0">Everyday <span class="text-[#366fed]">Spin & Win!</span></span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="max-w-[1145px] px-[15px] w-full mx-auto pb-[3.7em]">
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 grid-rows-1 gap-[8px]">
                        <div class="bg-white border border-[#c2cbde] rounded-[15px] overflow-hidden px-[20px] py-[25px] group transition-all">
                            <div class="w-[51px] h-[51px] rounded-[5px] bg-[#f3f4f9] flex items-center justify-center mb-2 transition-all">
                                <img src="@/../img/icons/life-ring.svg" alt="icon">
                            </div>
                            <span class="block text-[25px] font-[CircularBook] mb-2.5">24/7 Support</span>
                            <span class="block text-[13px] text-[#a4a6aa] mb-2 font-[CircularBook] transition-all">Got a problem? Just get in touch.</span>
                            <span class="block text-[13px] text-[#a4a6aa] font-[CircularBook] transition-all">Our support team is available 24/7.</span>
                        </div>
                        <div class="bg-white border border-[#c2cbde] rounded-[15px] overflow-hidden px-[20px] py-[25px] group transition-all">
                            <div class="w-[51px] h-[51px] rounded-[5px] bg-[#f3f4f9] flex items-center justify-center mb-2 transition-all">
                                <img src="@/../img/icons/shield-check.svg" alt="icon">
                            </div>
                            <span class="block text-[25px] font-[CircularBook] mb-2.5">Security First</span>
                            <span class="block text-[13px] text-[#a4a6aa] mb-2 font-[CircularBook] leading-[1.9] transition-all">All data from website is transmitted using encrypted Transport Layer Security (TLS) connections (i.e., HTTPS)</span>
                        </div>
                        <div class="bg-white border border-[#c2cbde] rounded-[15px] overflow-hidden px-[20px] py-[25px] group transition-all">
                            <div class="w-[51px] h-[51px] rounded-[5px] bg-[#f3f4f9] flex items-center justify-center mb-2 transition-all">
                                <img src="@/../img/icons/lock.svg" alt="icon">
                            </div>
                            <span class="block text-[25px] font-[CircularBook] mb-2.5">Secure Storage</span>
                            <span class="block text-[13px] text-[#a4a6aa] mb-2 font-[CircularBook] leading-[1.9] transition-all">99% of our users' funds are kept in a cold storage with multi-signature technologies</span>
                        </div>
                        <div class="bg-white border border-[#c2cbde] rounded-[15px] overflow-hidden px-[20px] py-[25px] group transition-all">
                            <div class="w-[51px] h-[51px] rounded-[5px] bg-[#f3f4f9] flex items-center justify-center mb-2 transition-all">
                                <img src="@/../img/icons/phone.svg" alt="icon">
                            </div>
                            <span class="block text-[25px] font-[CircularBook] mb-2.5">2FA Verifiction</span>
                            <span class="block text-[13px] text-[#a4a6aa] mb-2 font-[CircularBook] leading-[1.9] transition-all">Two-Factor Authentication (2FA) is required for actions such as withdrawals or changes in account settings</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {onMounted, ref} from "vue";
import {FeaturedMarkets, MarketTrend} from "../components"
import {globalStore} from "../stores"
const logged = ref(false)
const app_name = ref(import.meta.env.VITE_APP_NAME);


onMounted(() => {
    if (globalStore.userId) {
        logged.value = true;
    }
})
</script>
